export const SEASONS = ['spring', 'summer', 'autumn', 'winter']

export const SEASON_LABELS = {
  spring: 'Весна',
  summer: 'Лето',
  autumn: 'Осень',
  winter: 'Зима',
}

export const WHEEL_SIZE_LABELS = {
  stock: 'Сток',
  size_33: '33',
  size_35: '35',
  size_36: '36',
  size_37: '37',
  size_38: '38',
}

export const WHEEL_SIZE_FILTER_OPTIONS = [
  { value: '', label: 'Любые колёса' },
  ...Object.entries(WHEEL_SIZE_LABELS).map(([value, label]) => ({ value, label })),
]

const WHEEL_SIZE_ORDER = ['stock', 'size_33', 'size_35', 'size_36', 'size_37', 'size_38']

export function createDefaultDifficultyProfiles() {
  return SEASONS.map((season) => ({
    season,
    wheel_size: 'stock',
    winch_required: false,
  }))
}

export function wheelSizeLabel(wheelSize) {
  return WHEEL_SIZE_LABELS[wheelSize] || wheelSize
}

export function seasonLabel(season) {
  return SEASON_LABELS[season] || season
}

export function formatDifficultyProfile(profile) {
  if (!profile) return ''

  const parts = [wheelSizeLabel(profile.wheel_size)]
  if (profile.winch_required) {
    parts.push('лебёдка')
  }
  return parts.join(', ')
}

export function formatDifficultyProfiles(profiles) {
  if (!profiles?.length) return ''

  return profiles
    .map((profile) => `${seasonLabel(profile.season)}: ${formatDifficultyProfile(profile)}`)
    .join(' · ')
}

export function formatDifficultyProfilesSummary(profiles) {
  if (!profiles?.length) return 'Не указана'

  const summer = profiles.find((profile) => profile.season === 'summer')
  const winter = profiles.find((profile) => profile.season === 'winter')
  const parts = []

  if (summer) {
    parts.push(`Лето: ${formatDifficultyProfile(summer)}`)
  }
  if (winter) {
    parts.push(`Зима: ${formatDifficultyProfile(winter)}`)
  }

  if (parts.length > 0) {
    return parts.join(' · ')
  }

  return formatDifficultyProfile(largestWheelProfile(profiles))
}

function largestWheelProfile(profiles) {
  return [...profiles].sort(
    (left, right) => WHEEL_SIZE_ORDER.indexOf(right.wheel_size) - WHEEL_SIZE_ORDER.indexOf(left.wheel_size)
  )[0]
}

export function matchesDifficultyFilter(profiles, { season, wheelSize }) {
  if (!wheelSize) return true

  const profile = profiles?.find((entry) => entry.season === season)
  return profile?.wheel_size === wheelSize
}

export function formatDistance(meters) {
  if (meters >= 1000) {
    return `${(meters / 1000).toFixed(1)} км`
  }
  return `${meters} м`
}

export function formatDuration(seconds) {
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  if (hours > 0) {
    return `${hours} ч ${minutes % 60} мин`
  }
  return `${minutes} мин`
}

export function visibilityLabel(isPublic) {
  return isPublic ? 'Публичный' : 'Приватный'
}
